/* eslint-disable react/jsx-no-undef */
import { Button, CustomHeader, Screen, Text, TextInput } from "components"
import React, { useEffect, useRef, useState } from "react"
import {
  Platform,
  View,
  Image,
  ScrollView,
  PermissionsAndroid,
  TouchableOpacity,
} from "react-native"
import { style } from "./styles"
import { useNavigation } from "@react-navigation/native"
import { translate } from "i18n"
import flash from "config/flash"
import { useStores } from "models"
import { useSessionExpired } from "utils/function"
import { Controller, useForm } from "react-hook-form"
import validator from "validator"
import Modal from "react-native-modal"
import { useColor } from "app/theme/getThemes"
import { ActivityIndicator } from "react-native-paper"
import { launchImageLibrary } from "react-native-image-picker"
import { openCamera, uploadMedia } from "../EditProfile/helper/uploadImage"

export const FeedbackScreen = () => {
  const navigation = useNavigation<any>()
  const { userStore } = useStores()
  const { companyTheme } = useColor()

  const { sessionExpired } = useSessionExpired()

  const [userId, setUserId] = useState(null)
  const [selectedImage, setSelectedImage] = useState(null)

  const [loading, setIsLoading] = useState(false)

  const { control, handleSubmit, setValue, clearErrors } = useForm({
    reValidateMode: "onSubmit",
  })

  console.log("userStore", userStore)

  useEffect(() => {
    getMemberProfile()
  }, [])

  useEffect(() => {
    if (Platform.OS !== "web" && PermissionsAndroid.RESULTS.GRANTED) {
      requestCameraPermission()
    }
  }, [])

  const getMemberProfile = async () => {
    try {
      const res = await fetch(`${process.env.API_URL}/api/client/profile`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${userStore?.accessToken}`,
        },
      })

      if (res.ok) {
        const responseData = await res.json()
        const { email, name, contact_number } = responseData?.data

        console.log(responseData?.data)
        setUserId(responseData?.data?.member_id)
        setValue("user_mobile_number", contact_number?.substring(1))
        setValue("user_email", email)
        setValue("user_name", name)
      } else {
        const errorMsg = await res.json()
        if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
          sessionExpired()
        } else {
          flash("error", translate("errors.failedToRetreiveMember"))
        }
      }
    } catch (e) {
      console.log(`${process.env.API_URL}/api/client/profile`)
      flash("error", translate("errors.failedToRetreiveMember"))
      console.error(e)
    }
  }

  const onSubmit = async (data: any) => {
    console.log(data)

    let imageUrl = null;
    let shouldUpload = false;

    const formData = new FormData()
    if (Platform.OS === "web" && data.image) {
      shouldUpload = true;
    } else if (selectedImage?.uri) {
      shouldUpload = true;
    }

    if (shouldUpload) {
      const formData = new FormData()
      if (Platform.OS === "web") {
        formData.append("filename", data.image)
      } else {
        formData.append("filename", {
          uri: selectedImage.uri,
          name: selectedImage.name ?? "image.jpg",
          type: selectedImage.type ?? "image/jpeg",
        })
      }
      try {
        console.log(formData)
        const uploadRes = await fetch(`${process.env.API_URL}/api/upload/feedback`, {
          method: "POST",
          headers: {
            Authorization: `bearer ${userStore?.accessToken}`,
          },
          body: formData,
        })
        console.log(uploadRes)

        if (uploadRes.ok) {
          const respondData = await uploadRes.json()
          console.log(respondData)
          console.log("Upload successful")
          imageUrl = respondData?.data;
        } else {
          const errorMsg = await uploadRes.json()
          console.log(errorMsg)
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
            return;
          } else {
            flash("error", translate("feedBackScreen.failedUpload"))
            return;
          }
        }
      } catch (e) {
        flash("error", translate("feedBackScreen.failedUpload"))
        console.error(e)
        return;
      }
    }

    try {
      const feedbackRes = await fetch(`${process.env.API_URL}/api/member/feedback`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${userStore?.accessToken}`,
        },
        body: JSON.stringify({
          ...data,
          feedback_user: userId,
          feedback_image: imageUrl,
        }),
      })

      const res = {
        ...data,
        feedback_user: userId,
        feedback_image: imageUrl,
      }
      console.log(res)

      if (feedbackRes.ok) {
        console.log("Feedback submitted successfully")
        navigation.goBack()
        flash("success", translate("feedBackScreen.successUpload"))
      } else {
        const errorMsg = await feedbackRes.json()
        if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
          sessionExpired()
        } else {
          flash("error", translate("feedBackScreen.failedUpload"))
        }
      }
    } catch (e) {
      flash("error", translate("feedBackScreen.failedUpload"))
      console.error(e)
    }
  }

  const requestCameraPermission = async () => {
    try {
      const granted = await PermissionsAndroid.request(PermissionsAndroid.PERMISSIONS.CAMERA, {
        title: "App Camera Permission",
        message: "App needs access to your camera",
        buttonNeutral: "Ask Me Later",
        buttonNegative: "Cancel",
        buttonPositive: "OK",
      })
      if (granted === PermissionsAndroid.RESULTS.GRANTED) {
        console.log("Camera permission given")
      } else {
        console.log("Camera permission denied")
      }
    } catch (err) {
      console.warn(err)
    }
  }

  const fixImageFile = async (image: any) => {
    if (Platform.OS === "web") {
      return image // Web already gives real File
    } else {
      const response = await fetch(image.path)
      const blob = await response.blob()

      const fakeFile = {
        ...blob,
        name: image.filename || `upload_${Date.now()}.jpg`,
        lastModified: image.modificationDate ? Number(image.modificationDate) : Date.now(),
        lastModifiedDate: new Date(
          image.modificationDate ? Number(image.modificationDate) : Date.now(),
        ),
        webkitRelativePath: "",
        size: image.size,
        type: image.mime || "image/jpeg",
      }

      console.log("fakeFile", fakeFile)

      return fakeFile
    }
  }

  const onPressUpload = async (type: "camera" | "file") => {
    // if (Platform.OS === "web") {
    //   fileInputRef?.current?.click()
    //   console.log()
    // } else if (type === "camera") {
    //   openCamera((image: any) => {
    //     setValue("image", image)
    //     console.log(image)
    //     setSelectedImage(image)
    //     onCloseModal()
    //   })
    // } else if (type === "file") {
    //   uploadMedia(async (image: any) => {
    //     const fixedImage = await fixImageFile(image)

    //     console.log(fixedImage) // Now looks like REAL File
    //     setValue("image", fixedImage)
    //     setSelectedImage(image.path)
    //     onCloseModal()
    //   })
    // }

    if (Platform.OS === "web") {
      fileInputRef?.current?.click()
    } else if (type === "camera") {
      await openCamera((e) => {
        setSelectedImage({
          uri: e.path,
          name: `upload_${Date.now()}.jpg`,
          type: e.mime,
          ...e,
        })
        console.log(e)
        onCloseModal()
      })
    } else if (type === "file") {
      uploadMedia((e) => {
        setSelectedImage({
          uri: e.path,
          name: `upload_${Date.now()}.jpg`,
          type: e.mime,
          ...e,
        })
        console.log(e)
        onCloseModal()
      })
    }
  }

  const fileInputRef = useRef(null)

  const [isModalVisible, setIsModalVisible] = useState<boolean>(false)

  const onCloseModal = () => {
    setIsModalVisible(false)
  }
  return (
    <>
      <CustomHeader headerTitle={"Feedback"} height={100} showBackButton withBalls />

      <Screen preset="scroll">
        <View style={[style.container, { alignItems: "center", marginBottom: 50 }]}>
          {loading ? (
            <ActivityIndicator size="small" color={companyTheme.first} />
          ) : !selectedImage ? (
            <View>
              <Button
                onPress={() => {
                  if (Platform.OS === "web") {
                    onPressUpload("file")
                  } else {
                    setIsModalVisible(true)
                  }
                }}
                title="Capture Image"
              />

              {Platform.OS === "web" && (
                <input
                  accept="image/*"
                  ref={fileInputRef}
                  type="file"
                  // eslint-disable-next-line react-native/no-inline-styles
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const file = e.target.files?.[0]
                    if (file) {
                      uploadMedia(e, (image: any) => {
                        console.log(image)
                        setValue("image", image)
                        setSelectedImage(URL.createObjectURL(file))
                      })
                    }
                  }}
                />
              )}
            </View>
          ) : selectedImage ? (
            <View style={style.mediaContainer}>
              {Platform.OS === "web" ? (
                <Image
                  source={{ uri: selectedImage }}
                  style={[style.imageStyle, { marginTop: 10, marginBottom: 10 }]}
                  resizeMode="cover"
                />
              ) : (
                <Image
                  source={{ uri: selectedImage.uri }}
                  style={[style.imageStyle, { marginTop: 10, marginBottom: 10 }]}
                  resizeMode="cover"
                />
              )}
            </View>
          ) : null}

          {/* name */}
          <Controller
            name="user_name"
            control={control}
            rules={{
              required: translate("errors.required"),
            }}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
              return (
                <>
                  <TextInput
                    onFocus={() => clearErrors("name")}
                    value={value}
                    onChangeText={onChange}
                    error={error}
                    title={translate("registerScreen.fullName")}
                    errorMessage={error?.message}
                    placeholder={translate("registerScreen.fullNamePlaceholder")}
                    editable={false}
                  />
                </>
              )
            }}
          />

          {/* phoneNumber */}
          <Controller
            name="user_mobile_number"
            control={control}
            rules={{
              required: translate("errors.required"),
              validate: (value) =>
                validator.isMobilePhone(value, "ms-MY")
                  ? null
                  : translate("errors.invalidPhoneNumber"),
            }}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
              return (
                <>
                  <TextInput
                    onFocus={() => clearErrors("phoneNumber")}
                    keyboardType="numeric"
                    value={value}
                    onChangeText={onChange}
                    error={error}
                    title={translate("loginScreen.phoneNumber")}
                    errorMessage={error?.message}
                    placeholder={translate("loginScreen.phoneNumberPlaceholder")}
                    editable={false}
                  />
                </>
              )
            }}
          />

          {/* email */}
          <Controller
            name="user_email"
            control={control}
            rules={{
              required: translate("errors.required"),
              pattern: {
                value:
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: translate("errors.invalidEmail"),
              },
            }}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
              return (
                <>
                  <TextInput
                    onFocus={() => clearErrors("email")}
                    error={error}
                    errorMessage={error?.message}
                    title={translate("editProfileScreen.email")}
                    value={value}
                    onChangeText={onChange}
                    autoCapitalize="none"
                    autoComplete="email"
                    autoCorrect={false}
                    placeholder={translate("editProfileScreen.emailPlaceholder")}
                    editable={false}
                  />
                </>
              )
            }}
          />

          {/* feedback_title */}
          <Controller
            name="feedback_title"
            control={control}
            rules={{
              required: translate("errors.required"),
              maxLength: { value: 50, message: translate("errors.maxLength", { max: 50 }) },
            }}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
              return (
                <>
                  <TextInput
                    onFocus={() => clearErrors("feedback_title")}
                    value={value}
                    onChangeText={onChange}
                    error={error}
                    title={"FeedBack Title"}
                    errorMessage={error?.message}
                    placeholder={"FeedBack Title"}
                    maxLength={50}
                  />
                </>
              )
            }}
          />

          {/* feedback_message */}
          <Controller
            name="feedback_message"
            control={control}
            rules={{
              required: translate("errors.required"),
              maxLength: { value: 200, message: translate("errors.maxLength", { max: 50 }) },
            }}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
              return (
                <>
                  <TextInput
                    title="Issue / Feedback"
                    placeholder="Issue / Feedback"
                    multiline
                    textFieldStyle={{ height: 200 }}
                    textFieldContainer={{ borderRadius: 10, height: 200, paddingTop: 15 }}
                    value={value}
                    onChangeText={onChange}
                    error={error}
                    errorMessage={error?.message}
                    maxLength={200}
                  />
                </>
              )
            }}
          />

          <View style={{ width: "100%", marginTop: 20, marginBottom: 20 }}>
            <Button onPress={handleSubmit(onSubmit)} title={"Submit"} />
          </View>
        </View>

        <Modal
          isVisible={isModalVisible}
          style={style.modalContainer}
          onBackdropPress={() => onCloseModal()}
          onBackButtonPress={() => onCloseModal()}
        >
          <View style={style.modalContentContainer}>
            <TouchableOpacity
              style={[style.modalContentButton, { borderColor: companyTheme.first }]}
              onPress={() => {
                onPressUpload("camera")
              }}
            >
              <Text style={{ color: companyTheme.first }}>
                {translate("editProfileScreen.takePhoto")}
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[style.modalContentButton, { borderColor: companyTheme.first }]}
              onPress={() => {
                onPressUpload("file")
              }}
            >
              <Text style={{ color: companyTheme.first }}>
                {translate("editProfileScreen.uploadGallery")}
              </Text>
            </TouchableOpacity>
          </View>
        </Modal>
      </Screen>
    </>
  )
}
